/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum CableTrayConduitBase {
    Conduit = "Conduit",
    FieldFabConduit = "FieldFabConduit",
    LadderCableTray = "Ladder Cable Tray",
    ChannelCableTray = "Channel Cable Tray",
    WireMeshCableTray = "Wire Mesh Cable Tray",
    BusWay = "BusWay",
    WireWay = "WireWay"
}